/**
 * author       : zwl
 * createTime   : 2018/6/18 下午3:45
 * description  :
 */
import api from 'util/axios'
import {Message} from 'element-ui'

let instance = api.create({
  baseURL: '/api',
  timeout: 10000,
  headers: {'Content-Type': 'application/json'}
})
instance.defaults.retry = 2
instance.defaults.retryDelay = 1000
instance.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          break
        case 403:
          // 403 无权限，跳转到首页
          break
        case 500:
          let msg
          if (!error.response.data.msg) {
            msg = '服务器异常，请稍后再试！'
          } else {
            msg = error.response.data.msg
          }
          Message({
            message: msg,
            type: 'error',
            duration: 5 * 1000
          })
          break
      }
    } else if (error.request) {
      var config = error.config
      config.__retryCount = config.__retryCount || 0
      if (config.__retryCount >= config.retry) {
        Message({
          message: '请求超时，请稍后重试',
          type: 'error',
          duration: 5 * 1000
        })
        return Promise.reject(error)
      }
      config.__retryCount += 1
      var backoff = new Promise(function (resolve) {
        setTimeout(function () {
          resolve()
        }, config.retryDelay || 1)
      })
      return backoff.then(function () {
        config.baseURL = ''
        return instance(config)
      })
    }
    return Promise.reject(error)
  })

export function userlogin (username, password, imgCode, UUID) {
  return instance({
    method: 'post',
    url: '/authentication/form',
    params: {
      'username': username,
      'password': password,
      'imageCode': imgCode
    },
    auth: {
      username: 'weiwei',
      password: 'weiweisecret'
    },
    headers: {'deviceId': UUID}
  })
}

export function userPhoneLogin (phone, code, UUID) {
  return instance({
    method: 'post',
    url: '/authentication/mobile',
    params: {
      'mobile': phone,
      'smsCode': code
    },
    auth: {
      username: 'weiwei',
      password: 'weiweisecret'
    },
    headers: {'deviceId': UUID}
  })
}

export function refreshToken (refreshToken) {
  return instance({
    method: 'post',
    url: '/oauth/token',
    params: {
      'grant_type': 'refresh_token',
      'refresh_token': refreshToken
    },
    auth: {
      username: 'weiwei',
      password: 'weiweisecret'
    }
  })
}

export function getImageCode (UUID) {
  return instance({
    method: 'get',
    url: '/code/image?height=40&width=110',
    responseType: 'arraybuffer',
    auth: {},
    headers: {'deviceId': UUID}
  })
}

export function getPhoneCode (phone, UUID) {
  return instance({
    method: 'get',
    url: `/code/SMS?mobile=${phone}`,
    auth: {},
    headers: {'deviceId': UUID}
  })
}

export function sendCode (token, phone) {
  return instance({
    method: 'post',
    url: '/sysUser/register/code',
    params: {phone: phone, token: token}
  })
}

export function checkPasswordCode (phone, code) {
  return instance({
    method: 'post',
    url: '/sysUser/register/checkPassword',
    params: {phone: phone, code: code}
  })
}

export function sendPasswordCode (phone) {
  return instance({
    method: 'post',
    url: '/sysUser/register/forget',
    params: {phone: phone}
  })
}

export function resetPassword (param) {
  return instance({
    method: 'post',
    url: '/sysUser/register/resetPassword',
    data: param
  })
}

export function register (params) {
  return instance({
    method: 'post',
    url: '/sysUser/register',
    data: params
  })
}
